import { ResourceOptions } from 'react-admin';
import { FaAccessibleIcon } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';
// export { default as create } from './Create';
// export { default as edit } from './Edit';

export const name = Resources.feeManagement;
export const icon = FaAccessibleIcon;
export const options: ResourceOptions = {
  label: 'resource.fee-management',
};
